import { createAxiosInstance } from '../helpers/api.helper';

export const getFilesByPrefix = async (prefix) => {
    const request = await createAxiosInstance();

    return request({
        url: `/file/${prefix}/`,
        method: 'GET',
        data: {
            prefix
        }
    })
}

export const updateUserData = async (name, email) => {
    const request = await createAxiosInstance();

    return request({
        url: '/user/',
        method: 'PATCH',
        data: {
            name,
            email
        }
    })
}

export const getTitleByYoutubeURL = async (url) => {
    const request = await createAxiosInstance();

    return request({
        url: '/file/youtube/title',
        method: 'POST',
        data: {
            url
        }
    })
}

export const getUploadParams = async (path, content_type) => {
    const request = await createAxiosInstance();

    return request({
        url: `/file/upload/`,
        method: 'POST',
        data: {
            path,
            content_type
        },
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
    });
}

export const submitInferenceRequest = async (s3Filename, webFilename, title, email, mediaTypes) => {
    const request = await createAxiosInstance();

    const requestData = {
        'email': email,
        'modalities': mediaTypes,
        'filename': title,
        'mode': 'async',
        'run_visualisation': true,
        'run_description': mediaTypes.includes("image") ? false : false
    }

    if (s3Filename) requestData.s3Location = s3Filename
    if (webFilename) requestData.webLocation = webFilename

    return request({
        url: `/file/process/`,
        method: 'POST',
        data: requestData
    });
}

export const getVideoVisualisation = async (filename, faces, predictions) => {
    const request = await createAxiosInstance();

    const original_s3_path = "s3://deepfake-detection-api/" + filename
    return request({
        url: `/file/visualisation/`,
        method: 'POST',
        data: {
            original_s3_path,
            faces,
            predictions
        }
    });
}

export const getFileHistory = async (wantedModality, wantedStatuses, continuationToken) => {
    const request = await createAxiosInstance();

    let params = {
        wantedModality,
        wantedStatuses: wantedStatuses.join(",")
    }

    if (continuationToken != "null") {
        params['continuation_token'] = continuationToken
    }
    
    return request({
        url: `/file/new`,
        method: 'GET',
        params: params
    });
}

export const getUserUsage = async () => {
    const request = await createAxiosInstance();
    return request({
        url: `/user/usage/`,
        method: 'GET',
        data: {}
    });
}

export const getTopResultsForVideo = async (modality, md5) => {
    const request = await createAxiosInstance();
    return request({
        url: `/file/results/display/` + modality + `/` + md5,
        method: 'GET',
        data: {}
    });
}

export const deleteVideo = async (id) => {
    const request = await createAxiosInstance();

    return request({
        url: `/file/delete/`,
        method: 'DELETE',
        data: {
            ids: [id]
        }
    })
}